import { RequestHistory } from '../../../utils/headers';
import Loading from '../../Loading';
import DataTable from '../../Table/DataTable';

function HistorialConsultas({ items, loading }: any) {
    return loading ? (
        <Loading />
    ) : (
        <DataTable headers={RequestHistory} loading={loading} options={items} />
    );
}

export default HistorialConsultas;
